module.exports = __webpack_public_path__ + "static/media/logo-sm.a07a34e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo-sm.png
// module id = 638
// module chunks = 0